import { MultiEmailInputV2, ModalNormal } from '@/shared/ui/components';
import _ from 'lodash';
import { t } from 'ttag';
import { useModalEditEmail } from './useModalEditEmail';
import type { ModalEditEmailProps } from './modalEditEmail.types';
import './modalEditEmail.scss';

/**
 * Modal for editing the notification email list of a support request. Renders MultiEmailInputV2 over the emailList and emailInputValue held by useModalEditEmail with invalid-email errors, and disables Save while both the list and the pending input are empty.
 *
 * @param isOpen - Whether the modal is visible.
 * @param onClose - Callback closing the modal.
 * @param data - Current notification email data.
 * @param handleUpdateEmail - Callback persisting the edited email list.
 * @returns The edit notification email modal.
 */
const ModalEditEmail = ({ isOpen, onClose, data, handleUpdateEmail }: ModalEditEmailProps) => {
  const { state, handleClickSave, onChangeEmailList, onInputChange } = useModalEditEmail({
    isOpen,
    onClose,
    data,
    handleUpdateEmail,
  });

  return (
    <ModalNormal
      title={t`Edit notification email`}
      visible={isOpen}
      submitButtonName={t`Save`}
      handleCancel={onClose}
      handleSubmit={handleClickSave}
      disableSubmitButton={_.isEmpty(state.emailList) && !state.emailInputValue}
      loading={state.isSaving}
      hideCancelButton
      className="edit-noti-email-modal"
    >
      <div>
        <MultiEmailInputV2
          title={t`Notification email`}
          emailList={state.emailList}
          emailInputValue={state.emailInputValue}
          onChangeEmailList={onChangeEmailList}
          onInputChange={onInputChange}
          isError={!_.isEmpty(state.errorObject.invalidEmails)}
          errorMessage={state.errorObject.invalidEmails}
          disabled={state.isSaving}
        />
      </div>
    </ModalNormal>
  );
};

export default ModalEditEmail;
